import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex column items-start flex-1 gap-xs" }
const _hoisted_2 = { class: "fs-11px fw-500 text-cool-gray-100 q-mb-none" }

import { ref, computed } from 'vue'

interface IEmits {
  (event: 'update:model-value', data: null | string | number | Array<string | number>): void
}

interface IProps {
  size?: 'lg' | 'sm'
  status?: string
  title: string
  modelValue: null | string | number | Array<string | number>
  value: string | number
  disable?: boolean
  badgeTitle?: string
  badgeType?: 'error' | 'pause'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KCategoryPosCard',
  props: {
    size: { default: 'lg' },
    status: { default: '#dbe2ea' },
    title: {},
    modelValue: {},
    value: {},
    disable: { type: Boolean, default: false },
    badgeTitle: { default: '' },
    badgeType: { default: 'error' }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const isHoveredRef = ref(false)

const emit = __emit

const isSelected = computed(() => {
  if (Array.isArray(props.modelValue)) return props.modelValue.findIndex((item) => item === props.value) !== -1
  return props.modelValue === props.value
})

const state = computed(() => {
  if (props.disable) return 'disable'
  else if (isSelected.value) return 'selected'
  else if (isHoveredRef.value) return 'hover'
  return 'default'
})

function handleClick() {
  if (props.disable) return
  if (Array.isArray(props.modelValue)) {
    let newModelValue = [...props.modelValue]
    if (!isSelected.value) newModelValue.push(props.value)
    else newModelValue = newModelValue.filter((item) => item !== props.value)

    emit('update:model-value', newModelValue)
  } else {
    if (!isSelected.value) emit('update:model-value', props.value)
    else emit('update:model-value', null)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["k-category-pos-card relative-position", {
      'k-category-pos-card--disable': __props.disable,
    }]),
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHoveredRef.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHoveredRef.value = false)),
    onClick: handleClick
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["rounded-16 k-category-pos-card__box", {
        'k-category-pos-card__box--hovered': isHoveredRef.value && !__props.disable,
        'k-category-pos-card__box--selected': isSelected.value && !__props.disable,
        'k-category-pos-card__box--disable': __props.disable,
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["k-category-pos-card__white-box bg-static-light shadow-1 rounded-12 absolute", {
          'k-category-pos-card__white-box--hovered': isHoveredRef.value && !__props.disable,
          'k-category-pos-card__white-box--selected': isSelected.value && !__props.disable,
        }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["k-category-pos-card__white-box k-category-pos-card__white-box-rotated bg-static-light shadow-1 rounded-12 absolute", {
          'k-category-pos-card__white-box-rotated--hovered': isHoveredRef.value && !__props.disable,
          'k-category-pos-card__white-box-rotated--selected': isSelected.value && !__props.disable,
        }])
      }, null, 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["k-category-pos-card__main no-wrap column", [
        'q-px-12 q-pb-sm',
        {
          'k-category-pos-card__main--hovered': isHoveredRef.value,
          'k-category-pos-card__main--selected': isSelected.value,
          'k-category-pos-card__main--disable': __props.disable,
        },
      ]])
    }, [
      _createVNode(_component_KIcon, {
        class: "k-category-pos-card__main-icon",
        name: `category-pos-card-${state.value}`,
        "auto-height": ""
      }, null, 8, ["name"]),
      _createElementVNode("span", {
        class: "k-category-pos-card__status rounded-12 absolute",
        style: _normalizeStyle(`background-color:  ${__props.status}`)
      }, null, 4),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", {
          class: _normalizeClass(["fs-13px fw-600 q-mb-none k-category-pos-card__title q-mt-20", [!__props.disable ? 'text-cool-gray-100' : 'text-cool-gray-60']])
        }, _toDisplayString(__props.title), 3)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (__props.disable && __props.badgeTitle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["k-category-pos-card__badge rounded-16 flex items-center gap-xs bg-white", [`k-category-pos-card__badge--${__props.badgeType}`]])
        }, [
          _createVNode(_component_KIcon, {
            name: __props.badgeType === 'error' ? 'remove-solid' : 'pause',
            size: "16px"
          }, null, 8, ["name"]),
          _createElementVNode("p", _hoisted_2, _toDisplayString(__props.badgeTitle), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 34))
}
}

})